export const DATE_FORMAT_FILTER_COLUMN = 'DD [de] MMMM [de] YYYY';
export const DATE_FORMAT_COLUMN_TABLE = 'DD [de] MMMM [de] YYYY HH:mm'; // formato para columna de tabla
export const DATE_STRING_TO_MOMENT = 'YYYYMMDDHHmmss';
export const DATE_FORMAT_COLUMN_TABLE_2 = 'DD/MM/YYYY';
export const DATE_FORMAT_FORM = 'DD [de] MMMM [de] YYYY';
export const DATE_FORMAT_SHORT = 'DD/MMM/YY';
export const DATE_FORMAT_BD = 'YYYYMMDD';
